import styled from 'styled-components/macro'

import { numberWithCommas } from 'utils/formatters'

import { Quantity } from './Quantity'
import { Size } from 'features/Orders/Review/components/Overview/components/ProductsWidget/types'

export function Sizes({ sizes, hasSkuPricing = false }: Props) {
  return (
    <Container>
      {sizes.map(({ quantity, label, orderNbr, wholesalePrice }, index) => (
        <div className="size-item" key={`${orderNbr}-${index}`}>
          <Quantity
            quantity={numberWithCommas(quantity)}
            wholesalePrice={
              hasSkuPricing ? numberWithCommas(wholesalePrice) : undefined
            }
            label={label}
            noTranslateCaption
          />
        </div>
      ))}
    </Container>
  )
}

type Props = {
  sizes: Size[]
  hasSkuPricing?: boolean
}

const Container = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`
